import React from 'react'; import {
    Button
  } from '@material-ui/core';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  Elements,
  injectStripe,
} from 'react-stripe-elements';
import { styles } from './style';  
import { withStyles } from '@material-ui/core/styles'; 
import { translate } from 'react-i18next'; 
import { connect } from 'react-redux';

import InputFormat from '../../../partials/inputForm'
import Loading from '../../loading';
import Snackbar from '../../snackbar';
import '../../../css/paymentStripe.css'

 
class _PaymentStripe extends React.Component {
     constructor(props) {
        super(props);
        this.state = {
            amount: 0,
        }  
    }
    componentDidMount() {
        this.props.onRef(this)
    }
    handleOpenDialog = () => {
        this.PopUpInterface.handleDialogOpen()
    }
    handleCloseDialog = () => {
        this.PopUpInterface.handleDialogClose()
    }
    handleChange = (change) => {
      // console.log('[change]', change);
    };
    createOptions = (fontSize, padding) => {
      return {
        style: {
          base: {
            fontSize,
            color: '#424770',
            letterSpacing: '0.025em',
            fontFamily: 'Source Code Pro, monospace',
            '::placeholder': {
              color: '#aab7c4',
            },
            padding,
          },
          invalid: {
            color: '#9e2146',
          },
        },
      };
    };
    handleChangeInput = (e) => {
        let target = e.target;
        let name = target.name;
        let value = Number(target.value);
        this.setState({ [name]: value });
    }
    handleSubmit = (ev) => {
      ev.preventDefault();
      const _this = this;
      const {
          description,
          currencyCode,
          t
      } = this.props;
      this.loading.startLoading()
      if (this.props.stripe){
        this.props.stripe
        .createToken()
        .then(async (token) => {
          let data = {
              description: description,
              source: token.token.id,
              currency: currencyCode,
              amount: this.state.amount
          }
          let check = await _this.props.checkoutPayment(data)
          let checkPayment = await _this.props.addPayment({
            receiveMoney: this.state.amount
          })
          this.loading.stopLoading()
          if(check.code === 1 && checkPayment.code == 1){            
            _this.mSnackbar.handleClick(t("payment_add_payment_success"));
          }
          else if(check.code == 0){
            _this.mSnackbar.handleClick(`Error: ${check.message}`, 'error');  
          }
          else{
            _this.mSnackbar.handleClick(`Error: ${checkPayment.message}`, 'error');  
          }
          setTimeout(function(){
            _this.handleCloseDialog()
          }, 1000);
        });
      }
      else{
        this.loading.stopLoading()
        this.mSnackbar.handleClick("Stripe.js hasn't loaded yet.");
      }
    };
    render() {
        const { classes, t } = this.props;
        return (
          <form onSubmit={this.handleSubmit}>
            <Loading onRef={id => (this.loading = id)}/>
            <Snackbar
                color= "white"
                onRef={snackbar => (this.mSnackbar = snackbar)} 
            /> 
              <InputFormat
                  required
                  margin="normal"
                  value={this.state.amount}
                  name='amount'
                  label={'Amount'}
                  type="number"
                  fullWidth
                  autoComplete='off'
                  onChange={this.handleChangeInput}
              />
              <label>
                  {t("service_account_card_number")}
                  <CardNumberElement
                      // onBlur={this.handleBlur}
                      onChange={this.handleChange}
                      // onFocus={this.handleFocus}
                      // onReady={this.handleReady}
                      {...this.createOptions('18px')}
                  />
              </label>
              <label>
                  {t("service_account_card_expired")}
                  <CardExpiryElement
                      // onBlur={this.handleBlur}
                      onChange={this.handleChange}
                      // onFocus={this.handleFocus}
                      // onReady={this.handleReady}
                      {...this.createOptions('18px')}
                  />
              </label>
              <label>
                  {t("service_account_card_cvv")}
                  <CardCVCElement
                      // onBlur={this.handleBlur}
                      onChange={this.handleChange}
                      // onFocus={this.handleFocus}
                      // onReady={this.handleReady}
                      {...this.createOptions('18px')}
                  />
              </label>
          </form>
        );
    }
}
const mapState = state => ({
    currencyCode: state.setting.setting.currencyCode,
});
const mapDispatch = dispatch => ({
  checkoutPayment: dispatch.serviceAccount.checkoutPayment,
  addPayment: dispatch.serviceAccount.addPayment,
});
const PaymentStripe = connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(injectStripe(_PaymentStripe))));
class Index extends React.Component {
    componentDidMount() {
        this.props.onRef(this)
    }
    handleOpenDialog = () => {
        this.mPaymentStripe.handleOpenDialog()
    }
    render(){
        return(
            <Elements>
                <PaymentStripe
                    onRef={ref => this.mPaymentStripe = ref} 
                />
            </Elements> 
        )
    }
}
export default Index